import { Card, Stack, SegmentedControl, Group, Button, Text, Divider, Collapse } from '@mantine/core';
import OrgInfoGrid from '$/components/org.info.grid';
import { useState } from 'react';
import SeatsTable from '$/components/seats.table';
import SingleUserInvite from './manager.segments/single.usr.invite.tsx';

export default function ManagerView() {
    const [viewState, setViewState] = useState<'Users' | 'Teams' | 'Info'>('Users');
    const [actionRowState, setActionRowState] = useState<0 | 1 | 2>(0);

    const userActionsRow = () => {
        return (<Stack>
            <Collapse in={actionRowState !== 0}>
                {actionRowState === 1 && <SingleUserInvite />}
            </Collapse>
            <Group wrap="nowrap" justify="space-between">
                <Text size='1.2rem' >Granted Users</Text>
                <div hidden={actionRowState !== 0}>
                    <Button variant='light' mr={8} onClick={() => setActionRowState(1)}>Invite User</Button>
                    <Button variant='light' onClick={() => setActionRowState(2)}>Bulk Invite</Button>
                </div>
                {actionRowState !== 0 && <Button color='orange' variant='light' onClick={() => setActionRowState(0)}>Cancel</Button>}
            </Group>
        </Stack>)
    }

    return (<Stack gap={'md'} w={'90%'} mx={'auto'}>
        <Card withBorder w={'75%'} mx={'auto'}>
            <OrgInfoGrid />
        </Card>
        <SegmentedControl fullWidth data={['Users', 'Teams', 'Info']} color='yenta-blue' value={viewState} onChange={(value) => setViewState(value as typeof viewState)} />
        {viewState === 'Users' && userActionsRow()}
        <Divider />
        {viewState === 'Users' && <SeatsTable />}
        {viewState === 'Teams' && <div>Teams</div>}
        {viewState === 'Info' && <div>Info</div>}
    </Stack>);
}